import { NgModule } from '@angular/core';
import {
    LocationStrategy,
    PathLocationStrategy,
} from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CtFrameworkModule, CtFrameworkSetup, HttpLoaderFactory } from '@ctsolution/ct-framework';
import { environment } from "../environments/environment";
import { NotfoundComponent } from './modules/notfound/notfound.component';
import { AppLayoutModule } from "./_layout/app.layout.module";
import { NgxWebstorageModule } from "ngx-webstorage";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {
    CtAuthenticationModule,
    CtAuthenticationSetup
} from "@ctsolution/ct-authentication";
import { CtWebapiModule, CtWebapiSetup } from '@ctsolution/ct-webapi';
import { UserController } from './_core/controllers/user.controller';
import { DialogService } from 'primeng/dynamicdialog';
import { SpinnerModule } from './components/spinner/spinner.module';
import { FbAuctionMultipleDetailModule } from './components/fb-auction-multiple-detail/fb-auction-multiple-detail.module';
import { TermsDialogModule } from './components/terms-dialog/terms-dialog.module';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

export const AUTHENTICATION_CONFIG = CtAuthenticationSetup
    .create(environment.project.name, environment.API_URL)
    .setRedirectUrl("/authentication/login");

@NgModule({
    declarations: [AppComponent, NotfoundComponent],
    imports: [
        TermsDialogModule,
        CtAuthenticationModule.setup(AUTHENTICATION_CONFIG),
        AppRoutingModule,
        AppLayoutModule,
        SpinnerModule,
        FbAuctionMultipleDetailModule,
        CtWebapiModule.setup(
            CtWebapiSetup
              .create(environment.API_URL)
          ),
        CtFrameworkModule
            .forRoot(CtFrameworkSetup.create(environment.project.name)),
        NgxWebstorageModule.forRoot({ prefix: 'FB' }),
        TranslateModule.forRoot({
            defaultLanguage: 'it',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy },UserController,DialogService],
    bootstrap: [AppComponent],
})
export class AppModule {
}
